import { ConsumableQuantityEstimationThemeSizeConfig } from './types';

const small: ConsumableQuantityEstimationThemeSizeConfig = {
  consumableQuantityEstimation: {},
};

export default small;
